module.exports = __webpack_public_path__ + "img/my-type-ent.3edc1655.png";